import { render, staticRenderFns } from "./logisticsList.vue?vue&type=template&id=222920fd&scoped=true&"
import script from "./logisticsList.vue?vue&type=script&lang=js&"
export * from "./logisticsList.vue?vue&type=script&lang=js&"
import style0 from "./logisticsList.vue?vue&type=style&index=0&id=222920fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222920fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('222920fd')) {
      api.createRecord('222920fd', component.options)
    } else {
      api.reload('222920fd', component.options)
    }
    module.hot.accept("./logisticsList.vue?vue&type=template&id=222920fd&scoped=true&", function () {
      api.rerender('222920fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsList.vue"
export default component.exports